import styled, { css } from 'styled-components';

import { rotate } from '../layout/keyframes';

export const Spinner = styled.div`
  display: block;
  margin: 0 auto;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-top-color: transparent;
  animation: ${rotate} 600ms linear infinite;
`;

type WrapperProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  inline?: boolean;
  center?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  color: var(--element-color, ${(props) => props.theme.color.primary});

  ${({ inline }) =>
    inline &&
    css`
      display: inline-block;
      vertical-align: middle;
      color: currentColor !important;

      ${Spinner} {
        width: 1em;
        height: 1em;
      }
    `}

  ${({ center }) =>
    center &&
    css`
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}
`;
